import React, {  useState } from 'react'
import defaultPic from "./../../Images/user2.png";
import { useDispatch, useSelector } from 'react-redux';
import { getToken } from '../../RTK/Slice/Auth/AuthSlice';
import { AddPointAPI, blockAPI, editUserAPI, removeUserAPI, setExpirationAPI, unBlockAPI, UpdatePointAPI } from '../../RTK/Slice/Admin/AdminSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faPen, faPlus, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import {  faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { Backdrop, Fade, Modal } from '@mui/material';
import { confirmedPassword, notEmpty, validPassword } from '../../Validation';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import verifiedLogo from "./../../Images/verfi.webp";


 const UserRow = ({points,id , email,role , name , active , image,expirationDate , block , mobile}) => {

  const [isBlock , setIsBlock] = useState(block) ;  

  // For Access Point Field
  const [point , setPoint] = useState("") ; 


  // For Access Edit User Inputs
  const [username , setUsername] = useState(name) ;
  const [emailUser , setEmailUser ] = useState(email) ; 
  const [password , setPassword] = useState('') ; 
  const [confirmPassword , setConfirmPassword] = useState('') ;  
  // const [userMobile , setUserMobile] = useState(mobile) ;


  // For Control Edit User Model
  const [ showEditModel , setShowEditModel] = useState(false) ; 
  const handleShowEditModel = () => {setShowEditModel(true);};
  const handleCloseEditModel = () => {setShowEditModel(false) ; setPassword('');setConfirmPassword("") ; };




  const [updatePoint , setUpdatePoint] = useState(points ? points : "") ; 

  const [searchParams , setSearchParams] = useSearchParams() ;

  // For Access Expiration Field
  const [expirationTime , setExpirationTime] = useState("") ; 

  
  // For Control Add Point Modal
  const [open, setOpen] = useState(false);
  const handleOpen = () => {setOpen(true);};
  const handleClose = () => {setOpen(false) ; };

  // For Control Update Point Modal
  const [updateOpen, setUpdateOpen] = useState(false);
  const handleUpdateOpen = () => {setUpdateOpen(true);};
  const handleUpdateClose = () => {setUpdateOpen(false) ; };

  // For Control Update Point Modal
  const [expirationOpen, setOpenExpiration] = useState(false);
  const handleExpirationOpen = () => {setOpenExpiration(true);};
  const handleExpirationClose = () => {setOpenExpiration(false) ; };

  // For Modal Style
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    p: 4,
    };

  // For Access Token 
  const token = useSelector(getToken ) ; 

  // For Dispatch Action
  const dispatch = useDispatch() ; 

  const blockHandler = ()=>{
    if(block){
      dispatch(unBlockAPI({id , token}))
      setIsBlock(false) ;

    }else {
      dispatch(blockAPI({id , token}))
      setIsBlock(true) ;
    }
  }

  // For Cancel Edit User
  const cancelEditHandler = ()=>{
    handleCloseEditModel()
  }

  // For Update User Data
  const updateUserHandler = (e)=>{
    e.preventDefault() ;
    if(notEmpty(password) && notEmpty(confirmPassword) && notEmpty(username) && notEmpty(email)){
      if(confirmedPassword(password , confirmPassword)){
        if(validPassword(password)){
          dispatch(editUserAPI({username, email : emailUser , password , confirmPassword  , token , id})) ;
          handleCloseEditModel() 
        }else{
          toast.info("The password should start with capital letter and should have a small letter and numbers and specail Character #,$")
        }
      }else{
        toast.info("Password Does not match")
      }
    }else{
      toast.info("Please Enter Password Data")
    }
  }

  // For Add Point Handler 
  const addPointHandler = (e)=>{
    e.preventDefault() ; 
    if(Number.isInteger(parseInt(point)) && notEmpty(point && notEmpty(id)))
    {
      dispatch(AddPointAPI({token , userId : id , points : point , page : searchParams.get("page")  ?searchParams.get("page") :1 })) ; 
      setPoint("") ; 
    }
      
  }

  // For Add Point Handler 
  const UpdatePointHandler = (e)=>{
    e.preventDefault();
    if(Number.isInteger(parseInt(updatePoint)) && notEmpty(updatePoint && notEmpty(id)))
    {
      dispatch(UpdatePointAPI({token , userId : id , points : updatePoint , page : searchParams.get("page")  ?searchParams.get("page") :1 })) ; 
      setUpdatePoint("") ; 
    }
      
  }




  // For Render Add Point Modal
    const renderAddPointModal = ()=>{
      return (
          <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
              backdrop: {
              timeout: 300,
              },
          }}
          >
          <Fade in={open}>
              <form onSubmit={addPointHandler} className='k-modal my-font' style={style}>

                  <div className='head'>
                      <div className='left'>
                          <h3>Add Points</h3>
                          <p style={{display : "flex"}}>Please be carefull when add Points to <p style={{fontWeight :"bold" , margin : "0px 2px"}}> {` ${name ? name.length > 20 ?name.slice(0 , 13) :name  :""}`}</p>  </p>
                      </div>
                      <div className='right' onClick={handleClose}><FontAwesomeIcon  icon={faXmark} /></div>
                  </div>
                  <div className='body'>
                    <div className="row">
                      <label htmlFor="user">Point</label>
                      <input value={point} onChange={(e)=>setPoint(e.target.value)} className="input-row" type="number" placeholder="Enter Points"  />
                    </div>
                  </div>

                  <div className='btn'>
                      <button type="submit" className="add-token-btn" >Add Point</button>
                  </div>

              </form>
              
          </Fade>
      </Modal>
      )
  }

  // For Render Update Point Modal
    const renderUpdatePointModal = ()=>{
      return (
          <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={updateOpen}
          onClose={handleUpdateClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
              backdrop: {
              timeout: 300,
              },
          }}
          >
          <Fade in={updateOpen}>
              <form onSubmit={UpdatePointHandler} className='k-modal my-font' style={style}>

                  <div className='head'>
                      <div className='left'>
                          <h3>Update Points</h3>
                          <p style={{display : "flex"}}>Please be carefull when add Points to <p style={{fontWeight :"bold" , margin : "0px 2px"}}> {` ${name ? name.length > 20 ?name.slice(0 , 13) :name  :""}`}</p>  </p>
                      </div>
                      <div className='right' onClick={handleUpdateClose}><FontAwesomeIcon  icon={faXmark} /></div>
                  </div>
                  <div className='body'>
                    <div className="row">
                      <label htmlFor="user">Point</label>
                      <input value={updatePoint} onChange={(e)=>setUpdatePoint(e.target.value)} className="input-row" type="number" placeholder="Enter Points"  />
                    </div>
                  </div>

                  <div className='btn'>
                      <button type='submit' className="add-token-btn" >Update Point</button>
                  </div>

              </form>
              
          </Fade>
      </Modal>
      )
  }

    // For Render Add Point Modal
    const renderSetExpirationModal = ()=>{
      return (
          <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={expirationOpen}
          onClose={handleExpirationClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
              backdrop: {
              timeout: 300,
              },
          }}
          >
          <Fade in={expirationOpen}>
              <form onSubmit={setExpirationHandler} className='k-modal my-font' style={style}>

                  <div className='head'>
                      <div className='left'>
                          <h3>Epiration </h3>
                          <p style={{display : "flex"}}>Please be carefull when set the expiration <p style={{fontWeight :"bold" , margin : "0px 2px"}}> {` ${name ? name.length > 20 ?name.slice(0 , 13) :name  :""}`}</p>  </p>
                      </div>
                      <div className='right' onClick={handleExpirationClose}><FontAwesomeIcon  icon={faXmark} /></div>
                  </div>
                  <div className='body'>
                    <div className="row">
                      <label htmlFor="user">Expiration</label>
                      <input value={expirationTime} onChange={(e)=>setExpirationTime(e.target.value)} className="input-row" type="date" placeholder="Choose Date"  />
                    </div>
                  </div>

                  <div className='btn'>
                      <button type='submit' className="add-token-btn" >Set Date</button>
                  </div>

              </form>
              
          </Fade>
      </Modal>
      )
  }

  // For Style Edit User Model
  const styleEditModel = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 540,
    height : 545
    };

  // For Render edit model
  const renderEditUserModel = ()=>{
    return (
      <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={showEditModel}
          onClose={handleCloseEditModel}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
              backdrop: {
              timeout: 300,
              },
          }}
          >
          <Fade in={showEditModel}>
            <div className='edit-user-model' style={styleEditModel} >

              <div className='edit-model-heaer'>
                <div className='top-header'></div>
                <div className='user-info'>
                  <div className='user-image'> {role !== "user" ? (<img alt='verifyLogo' src={verifiedLogo} className='verify-logo' />) :""}  <img src={defaultPic} alt='user' /> </div>
                  <div className='data-names'>
                    <h3 className='username'>{name}</h3>
                    <p>{email}</p>
                  </div>
                </div>
              </div>

              <form onSubmit={updateUserHandler} className='edit-form'>

                <div className='row'>
                  <label htmlFor='username'>Username</label>
                  <div className='input-data'>
                    <input placeholder='Enter Usename' onChange={(e)=>setUsername(e.target.value)} value={username} />
                  </div>
                </div>
                <div className='row'>
                  <label htmlFor='username'>Email address</label>
                  <div className='input-data'>
                    <input placeholder='Enter Email' value={emailUser} onChange={(e)=>setEmailUser(e.target.value)} />
                  </div>
                </div>
                <div className='row'>
                  <label htmlFor='username'>New Password</label>
                  <div className='input-data'>
                    <input placeholder='Enter New Password' value={password} onChange={(e)=>setPassword(e.target.value)} />
                  </div>
                </div>
                <div className='row'>
                  <label htmlFor='username'>Confrim Password</label>
                  <div className='input-data'>
                    <input placeholder='confirm passsword' value={confirmPassword} onChange={(e)=>setConfirmPassword(e.target.value)} />
                  </div>
                </div>
                
                <div className='row btns-edit'>
                  <button type="button" className='delete-user-btn' onClick={()=>removeUserHandlere(id)} ><FontAwesomeIcon icon={faTrashCan} />Delete user</button>
                  <div className='cancel-btns'>
                    <button className='cancel-btn' type="button" onClick={cancelEditHandler}>Cancel</button>
                    <button className='save-btn'>Save Changes</button>
                  </div>
                </div>
              </form>

            </div>
              
          </Fade>
      </Modal>
    )
  }


  // For Access Remove Status
  // const removeStatus = useSelector(getRemoveStatus) ;

  // For Remove User Handler 
  const removeUserHandlere = (id)=>{
    if(notEmpty(id)){
      dispatch(removeUserAPI({token , id , name})) ; 
      handleCloseEditModel() ;
    }
  }

  // For Set Time Handler 
  const setExpirationHandler = (e)=>{
    e.preventDefault() ; 
  if(notEmpty(expirationTime)){
    dispatch(setExpirationAPI({userId: id , page:searchParams.get("page") ? searchParams.get("page"):1 , token , expiredAt : expirationTime}))
  }
    
  else{
    toast.info("Please set date")
  }
  }



  return (
    <div className='row'>
    {renderAddPointModal()}
    {renderUpdatePointModal()}
    {renderSetExpirationModal()}
    {renderEditUserModel()}
        <div className='cell'> 
          <img src={defaultPic}  alt='user' /> 
          <div  style={{width : "124px" , maxWidth : "100%"}}>
            <p style={{width : "70%"}} data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  data-tooltip-content={name} >{name ? name.length > 20 ? `${name.slice(0 , 18)}...` : name :"Unknow"} <span onClick={handleShowEditModel} className='btn-edit'><FontAwesomeIcon className='edite-user-icon' icon={faPen} /></span> </p>
            <p className='user-email' data-tooltip-id="my-tooltip" data-tooltip-delay-show={800}  data-tooltip-content={email}>{email.length > 13 ?`${email.slice(0 , 13)}...` :email}  </p>
          </div>
        </div>
        <div className='cell'><p>{mobile ? mobile.length > 13 ? mobile.slice(0 , 13) :mobile : "UnKnow"}</p></div>
        <div className='cell'><p >{expirationDate  ? expirationDate?.slice(0 ,10) : "No Expiration"}</p> <button onClick={handleExpirationOpen} className='manage-point-btn'><FontAwesomeIcon icon={faCalendar} /></button></div>
        <div className='cell'><p className={`point ${parseInt(points) >= 1000 ? 'point-high' :(parseInt(points) >= 500 && parseInt(points) < 1000) ?"point-medium" : "point-low"  }`}>
        {points}</p>
        <button className='manage-point-btn' onClick={handleOpen}><FontAwesomeIcon icon={faPlus} /></button>
        <button className='manage-point-btn' onClick={handleUpdateOpen} ><FontAwesomeIcon icon={faPen} /></button>
        </div>
        <div className='cell'><p className={`${active ? 'active' : 'not-active'}`}>{active ? "Active" : "Disabled"}</p></div>
        <div className='cell'> <div onClick={blockHandler} className={`slide ${block ? "active-slide" : "not-slide"} `}> <span className={`ball ${block ? "ball-active" : "ball-not-active"}`}></span> </div> </div>
        <div className='cell'><button onClick={()=>removeUserHandlere(id)}  className='del-btn'>  <FontAwesomeIcon   icon={faTrash} /> </button></div>
    </div>
  )
}



export default UserRow